// German for the evidence corpus: masthead, rail, holds, the grid, the panel, the modals.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── masthead ──
  'Documents': 'Dokumente',
  'No engagement selected': 'Kein Auftrag ausgewählt',
  'Evidence is always scoped to one engagement — pick one in the top bar and its corpus loads here.': 'Belege gehören immer zu genau einem Auftrag — wählen Sie oben einen aus, und sein Korpus lädt hier.',
  'Release to ingest into': 'Loslassen zum Einlesen in',
  'The evidence corpus of': 'Der Belegkorpus von',
  'everything a requirement is allowed to cite': 'alles, was eine Anforderung zitieren darf',
  'Link documents the client library already has — nothing is copied': 'Dokumente verknüpfen, die die Kundenbibliothek bereits hat — nichts wird kopiert',
  'Add from library': 'Aus Bibliothek hinzufügen',
  'New note': 'Neue Notiz',
  'Ingesting…': 'Wird eingelesen…',
  'Upload files': 'Dateien hochladen',

  // ── the rail (t(cell.key) + units/details) ──
  'CORPUS': 'KORPUS',
  'DATED': 'DATIERT',
  'READ': 'GELESEN',
  'PAIRS': 'PAARE',
  'YIELD': 'ERTRAG',
  'filter': 'Filter',
  'the corpus did not load': 'der Korpus wurde nicht geladen',
  'doc': 'Dok.',
  'docs': 'Dok.',
  '{live} live · {superseded} superseded': '{live} aktiv · {superseded} ersetzt',
  '{live} live · none superseded': '{live} aktiv · keines ersetzt',
  '{a} of {b}': '{a} von {b}',
  '{n} effective date unconfirmed': '{n} Stichtag unbestätigt',
  '{n} effective dates unconfirmed': '{n} Stichtage unbestätigt',
  'every effective date confirmed': 'jeder Stichtag bestätigt',
  '{n} awaiting OCR': '{n} warten auf OCR',
  'every document has a text layer': 'jedes Dokument hat eine Textebene',
  'open': 'offen',
  'near-duplicates undecided': 'Beinahe-Duplikate unentschieden',
  'every near-duplicate decided': 'jedes Beinahe-Duplikat entschieden',
  'span': 'Stelle',
  'spans': 'Stellen',
  '{cited} of {live} cited · {dark} dark': '{cited} von {live} zitiert · {dark} unzitiert',
  'every document cited': 'jedes Dokument zitiert',

  // ── toasts ──
  'Failed to load document': 'Dokument konnte nicht geladen werden',
  '{n} ingested': '{n} eingelesen',
  '{n} already on file': '{n} bereits abgelegt',
  '{n} not accepted': '{n} nicht akzeptiert',
  'Nothing was ingested': 'Nichts wurde eingelesen',
  '{summary} — the per-file report is the first hold': '{summary} — der Bericht pro Datei ist der erste Vorbehalt',
  'Upload failed': 'Upload fehlgeschlagen',
  'Upload failed — {reason}': 'Upload fehlgeschlagen — {reason}',
  'Effective date confirmed': 'Stichtag bestätigt',
  'Could not confirm date': 'Datum konnte nicht bestätigt werden',
  'None of the selected documents has a detected date waiting to be confirmed': 'Keines der ausgewählten Dokumente hat ein erkanntes Datum, das auf Bestätigung wartet',
  '{done} confirmed · {refused} refused — {reason}': '{done} bestätigt · {refused} abgelehnt — {reason}',
  '{n} date': '{n} Datum',
  '{n} dates': '{n} Daten',
  '{n} effective date confirmed in one act': '{n} Stichtag in einem Zug bestätigt',
  '{n} effective dates confirmed in one act': '{n} Stichtage in einem Zug bestätigt',
  'Could not confirm the dates': 'Die Daten konnten nicht bestätigt werden',
  'Date set and confirmed': 'Datum gesetzt und bestätigt',
  'Could not set the date': 'Das Datum konnte nicht gesetzt werden',
  'Re-reading — the current text will be replaced': 'Wird neu gelesen — der aktuelle Text wird ersetzt',
  'Queued for reading': 'Zum Lesen eingereiht',
  'Could not start OCR': 'OCR konnte nicht gestartet werden',
  'None of the selected documents is a format the vision model can read': 'Keines der ausgewählten Dokumente hat ein Format, das das Vision-Modell lesen kann',
  'Queued {done} of {total} — {failed} could not start': '{done} von {total} eingereiht — {failed} konnten nicht starten',
  'Queued {n} document for reading': '{n} Dokument zum Lesen eingereiht',
  'Queued {n} documents for reading': '{n} Dokumente zum Lesen eingereiht',
  'Queued — the librarian will replace the current classification': 'Eingereiht — der Bibliothekar ersetzt die aktuelle Klassifikation',
  'Queued for classification': 'Zur Klassifikation eingereiht',
  'Could not start the librarian': 'Der Bibliothekar konnte nicht gestartet werden',
  'None of the selected documents has text for the librarian to read': 'Keines der ausgewählten Dokumente hat Text, den der Bibliothekar lesen könnte',
  'Queued {done} of {total} for re-filing — {failed} could not start': '{done} von {total} zur Neuablage eingereiht — {failed} konnten nicht starten',
  'Queued {n} document for re-filing': '{n} Dokument zur Neuablage eingereiht',
  'Queued {n} documents for re-filing': '{n} Dokumente zur Neuablage eingereiht',
  'Classification held — it is yours now, not the librarian’s': 'Klassifikation übernommen — sie gehört jetzt Ihnen, nicht dem Bibliothekar',
  'Could not hold the classification': 'Die Klassifikation konnte nicht übernommen werden',
  '{ref} updated': '{ref} aktualisiert',
  'Update failed': 'Aktualisierung fehlgeschlagen',
  'Marked as superseded': 'Als ersetzt markiert',
  'Supersession cleared': 'Ersetzung aufgehoben',
  'Supersession failed': 'Ersetzung fehlgeschlagen',
  'Supersession recorded — recency arbitration now has an order': 'Ersetzung erfasst — der Aktualitätsabgleich hat jetzt eine Reihenfolge',
  'Recorded as reviewed — the hint keeps its reason, the badge stands down': 'Als geprüft erfasst — der Hinweis behält seine Begründung, die Markierung tritt zurück',
  'Could not dismiss the hint': 'Der Hinweis konnte nicht verworfen werden',
  '{n} linked to existing': '{n} mit bestehenden verknüpft',
  '{n} already present': '{n} bereits vorhanden',
  '{n} still unsupported': '{n} weiterhin nicht unterstützt',
  'Re-scan of {ref}: {parts}': 'Neuscan von {ref}: {parts}',
  'Re-scan of {ref}: no attachments found': 'Neuscan von {ref}: keine Anhänge gefunden',
  'Attachment re-scan failed': 'Neuscan der Anhänge fehlgeschlagen',
  'Could not work out what deleting this would do': 'Es liess sich nicht ermitteln, was das Löschen bewirken würde',
  '{ref} deleted — the stored file went with it': '{ref} gelöscht — die gespeicherte Datei ging mit',
  '{ref} deleted': '{ref} gelöscht',
  'Delete failed': 'Löschen fehlgeschlagen',
  '{ref} unlinked from {code} — it stays in the client library': 'Verknüpfung von {ref} mit {code} gelöst — es bleibt in der Kundenbibliothek',
  'Could not unlink the document': 'Die Verknüpfung des Dokuments konnte nicht gelöst werden',
  'refused': 'abgelehnt',
  '{done} unlinked · {refused} refused — {first}': '{done} gelöst · {refused} abgelehnt — {first}',
  '{n} document unlinked from {code}': 'Verknüpfung von {n} Dokument mit {code} gelöst',
  '{n} documents unlinked from {code}': 'Verknüpfung von {n} Dokumenten mit {code} gelöst',
  'this engagement': 'diesem Auftrag',
  '{ref} note created': 'Notiz {ref} erstellt',
  'Could not save note': 'Notiz konnte nicht gespeichert werden',
  'Could not load the client library': 'Die Kundenbibliothek konnte nicht geladen werden',
  '{ref} linked into {code} — it stays in the client library': '{ref} in {code} verknüpft — es bleibt in der Kundenbibliothek',
  'Could not link the document': 'Das Dokument konnte nicht verknüpft werden',

  // ── HOLDS ──
  'Holds': 'Vorbehalte',
  '{n} kind of hold': '{n} Art von Vorbehalt',
  '{n} kinds of hold': '{n} Arten von Vorbehalten',
  'clear‖holds': 'frei',
  'clear‖filter': 'zurücksetzen',
  'The corpus did not load': 'Der Korpus wurde nicht geladen',
  'Nothing is holding the corpus': 'Nichts hält den Korpus zurück',
  'Every effective date confirmed, every near-duplicate decided, every readable file read. The corpus is ready for extraction.': 'Jeder Stichtag bestätigt, jedes Beinahe-Duplikat entschieden, jede lesbare Datei gelesen. Der Korpus ist bereit für die Extraktion.',
  'Last ingest —': 'Letztes Einlesen —',
  'file': 'Datei',
  'files': 'Dateien',
  'ingested': 'eingelesen',
  'already on file': 'bereits abgelegt',
  'not accepted': 'nicht akzeptiert',
  '— a file that never became a document is a hold, not a toast.': '— eine Datei, die nie zum Dokument wurde, ist ein Vorbehalt, keine Meldung.',
  'Dismiss': 'Ausblenden',
  'created': 'erstellt',
  'The client library already had these bytes — the existing document was linked in': 'Die Kundenbibliothek hatte diese Bytes bereits — das bestehende Dokument wurde verknüpft',
  'linked': 'verknüpft',
  'duplicate': 'Duplikat',
  'failed': 'fehlgeschlagen',
  'Recorded on the existing document': 'Auf dem bestehenden Dokument vermerkt',
  're-uploaded': 'erneut hochgeladen',
  'Open': 'Öffnen',
  'effective date unconfirmed': 'Stichtag unbestätigt',
  'effective dates unconfirmed': 'Stichtage unbestätigt',
  'Until you confirm them, recency arbitration is running on Signet’s guess.': 'Bis Sie sie bestätigen, läuft der Aktualitätsabgleich auf Signets Vermutung.',
  '{n} of them have no detected date at all — set those by hand in the grid.': '{n} davon haben gar kein erkanntes Datum — setzen Sie diese von Hand im Raster.',
  'Hide the list': 'Liste ausblenden',
  'Check the list': 'Liste prüfen',
  'Confirming…': 'Wird bestätigt…',
  'Confirm {n}': '{n} bestätigen',
  'detected from {source}': 'erkannt aus {source}',
  'source': 'Quelle',
  'no date found — set it by hand': 'kein Datum gefunden — von Hand setzen',
  'Unticking a row leaves it unconfirmed and in the count; correcting a date is one click on the date cell in the grid.': 'Ein abgewähltes Dokument bleibt unbestätigt und in der Zählung; ein Datum korrigieren Sie mit einem Klick auf die Datumszelle im Raster.',
  'near-duplicate pair undecided': 'Beinahe-Duplikat-Paar unentschieden',
  'near-duplicate pairs undecided': 'Beinahe-Duplikat-Paare unentschieden',
  'While a pair is open, recency arbitration has no order and the agent may cite the stale half of it.': 'Solange ein Paar offen ist, hat der Aktualitätsabgleich keine Reihenfolge, und der Agent könnte die veraltete Hälfte zitieren.',
  'Close': 'Schliessen',
  'Decide pairs': 'Paare entscheiden',
  'document with no text layer': 'Dokument ohne Textebene',
  'documents with no text layer': 'Dokumente ohne Textebene',
  'Stored and flagged, never dropped — but nothing can cite a document Signet cannot read.': 'Gespeichert und markiert, nie verworfen — aber nichts kann ein Dokument zitieren, das Signet nicht lesen kann.',
  'The vision model is unreachable': 'Das Vision-Modell ist nicht erreichbar',
  'Read {n} with OCR': '{n} mit OCR lesen',
  'document the agent has never opened': 'Dokument, das der Agent nie geöffnet hat',
  'documents the agent has never opened': 'Dokumente, die der Agent nie geöffnet hat',
  'Never in any run’s': 'In keinem Lauf je unter',
  'G1 cannot close on a corpus nobody has read.': 'G1 kann nicht über einem Korpus schliessen, den niemand gelesen hat.',
  'Show them': 'Anzeigen',
  'Queue for extraction': 'Zur Extraktion einreihen',

  // ── CORPUS ──
  'Corpus': 'Korpus',
  '{shown} of {total} documents': '{shown} von {total} Dokumenten',
  '{n} document': '{n} Dokument',
  '{n} documents': '{n} Dokumente',
  'No evidence ingested yet': 'Noch keine Belege eingelesen',
  'Nothing is linked to': 'Nichts ist verknüpft mit',
  'Drop the discovery corpus onto this page — transcripts, client specs, screenshots — or link what the client library already has.': 'Ziehen Sie den Discovery-Korpus auf diese Seite — Transkripte, Kundenspezifikationen, Screenshots — oder verknüpfen Sie, was die Kundenbibliothek bereits hat.',
  'All': 'Alle',
  'none filed as {folders}': 'keines abgelegt als {folders}',
  'Sorting': 'Sortierung',
  'by effective date, newest first': 'nach Stichtag, neueste zuerst',
  'by yield, richest first': 'nach Ertrag, ergiebigste zuerst',
  'by ingest, newest first': 'nach Einlesen, neueste zuerst',
  'Search refs, names, summaries, tags, full text…': 'Refs, Namen, Zusammenfassungen, Tags, Volltext durchsuchen…',
  'clear filters': 'Filter zurücksetzen',
  'Status filter:': 'Statusfilter:',
  'The text search failed: {error} — showing only refs and filenames.': 'Die Textsuche ist fehlgeschlagen: {error} — es werden nur Refs und Dateinamen gezeigt.',
  'Searching the corpus text…': 'Korpustext wird durchsucht…',
  'in refs and filenames': 'in Refs und Dateinamen',
  'only in summaries, tags or full text': 'nur in Zusammenfassungen, Tags oder Volltext',
  'selected': 'ausgewählt',
  'Confirm dates': 'Daten bestätigen',
  'Read with OCR': 'Mit OCR lesen',
  'Re-file with the librarian': 'Mit dem Bibliothekar neu ablegen',
  'Unlink from {code}': 'Verknüpfung mit {code} lösen',
  'Clear': 'Zurücksetzen',
  'Nothing matches “{q}”': 'Nichts entspricht «{q}»',
  'Nothing here under these filters': 'Unter diesen Filtern ist hier nichts',
  'The corpus search reads refs, filenames, summaries, tags and the extracted text of every document — try a phrase you remember reading.': 'Die Korpussuche liest Refs, Dateinamen, Zusammenfassungen, Tags und den extrahierten Text jedes Dokuments — versuchen Sie eine Wendung, an die Sie sich erinnern.',
  'The corpus has {n} document.': 'Der Korpus hat {n} Dokument.',
  'The corpus has {n} documents.': 'Der Korpus hat {n} Dokumente.',
  'Clear the filters': 'Filter zurücksetzen',
  'Select all shown': 'Alle angezeigten auswählen',
  'Effective': 'Stichtag',
  'Ref': 'Ref',
  'Document': 'Dokument',
  'Yield': 'Ertrag',
  'Hold‖corpus': 'Vorbehalt',

  // ── the row ──
  'pair open': 'Paar offen',
  'needs OCR': 'braucht OCR',
  'Reading with the vision model': 'Wird mit dem Vision-Modell gelesen',
  'reading…': 'wird gelesen…',
  'The librarian is filing this document': 'Der Bibliothekar legt dieses Dokument ab',
  'filing…': 'wird abgelegt…',
  'extraction failed': 'Extraktion fehlgeschlagen',
  '{n} attachment unread': '{n} Anhang ungelesen',
  'Identical bytes arrived again and were not duplicated': 'Identische Bytes kamen erneut an und wurden nicht dupliziert',
  're-uploaded {n}×': '{n}× erneut hochgeladen',
  'Save and confirm': 'Speichern und bestätigen',
  'Confirmed by the operator': 'Vom Operator bestätigt',
  'Detected from {source} — unconfirmed': 'Erkannt aus {source} — unbestätigt',
  'Type the date the content was true — saved and confirmed in one step': 'Geben Sie das Datum ein, an dem der Inhalt galt — in einem Schritt gespeichert und bestätigt',
  'set date': 'Datum setzen',
  'Classification held by you': 'Klassifikation von Ihnen übernommen',
  'Classified by the librarian — not yet held': 'Vom Bibliothekar klassifiziert — noch nicht übernommen',
  'unfiled': 'nicht abgelegt',
  '{n} pp': '{n} S.',
  '{n} chars': '{n} Zeichen',
  'in {n} requirement': 'in {n} Anforderung',
  'in {n} requirements': 'in {n} Anforderungen',
  'never opened': 'nie geöffnet',
  'read, nothing cited': 'gelesen, nichts zitiert',
  'coverage unknown': 'Abdeckung unbekannt',
  // month groups (monthOf) — English month name + year, translated in DocRow
  'January': 'Januar', 'February': 'Februar', 'March': 'März', 'April': 'April', 'May': 'Mai', 'June': 'Juni',
  'July': 'Juli', 'August': 'August', 'September': 'September', 'October': 'Oktober', 'November': 'November', 'December': 'Dezember',
  'No effective date': 'Kein Stichtag',

  // ── the panel ──
  'client #{id}': 'Kunde #{id}',
  'linked to': 'verknüpft mit',
  'not linked to any engagement': 'mit keinem Auftrag verknüpft',
  'The librarian has not summarised this document.': 'Der Bibliothekar hat dieses Dokument nicht zusammengefasst.',
  '{spans} in {reqs}': '{spans} in {reqs}',
  '{n} span': '{n} Stelle',
  '{n} spans': '{n} Stellen',
  '{n} requirement': '{n} Anforderung',
  '{n} requirements': '{n} Anforderungen',
  'read by the agent, nothing cited': 'vom Agenten gelesen, nichts zitiert',
  'never opened by the agent': 'vom Agenten nie geöffnet',
  'further spans —': 'weitere Stellen —',
  'open the register filtered to {ref}': 'Register gefiltert auf {ref} öffnen',
  'Nothing in the register cites this document.': 'Nichts im Register zitiert dieses Dokument.',
  'An extraction run has read it, so this is a finding, not a gap — the document carries no requirement.': 'Ein Extraktionslauf hat es gelesen; das ist also ein Befund, keine Lücke — das Dokument trägt keine Anforderung.',
  'No extraction run has ever opened it.': 'Kein Extraktionslauf hat es je geöffnet.',
  'Until one does, the register has not been checked against it.': 'Bis einer das tut, wurde das Register nicht dagegen geprüft.',
  'No run coverage is recorded for this engagement.': 'Für diesen Auftrag ist keine Laufabdeckung erfasst.',
  'Run a targeted pass over {ref}': 'Gezielten Durchgang über {ref} starten',
  'Queue {ref} for extraction': '{ref} zur Extraktion einreihen',
  'Effective date': 'Stichtag',
  'not detected': 'nicht erkannt',
  '— unconfirmed. The file mtime is never used.': '— unbestätigt. Die Datei-Änderungszeit wird nie verwendet.',
  'Confirm': 'Bestätigen',
  'decided': 'entschieden',
  'Decide the pair': 'Paar entscheiden',
  'names this document as a near-duplicate:': 'nennt dieses Dokument als Beinahe-Duplikat:',
  'No text layer.': 'Keine Textebene.',
  'Reading…‖ocr': 'Wird gelesen…',
  'Extraction failed:': 'Extraktion fehlgeschlagen:',
  'attachment(s) were unsupported at ingest:': 'Anhang/Anhänge beim Einlesen nicht unterstützt:',
  'Re-scanning…': 'Wird neu gescannt…',
  'Re-scan attachments': 'Anhänge neu scannen',
  'Classification': 'Klassifikation',
  'held by you': 'von Ihnen übernommen',
  'the librarian’s, not yet held': 'vom Bibliothekar, noch nicht übernommen',
  'Form — the document’s kind': 'Form — die Art des Dokuments',
  '— unclassified —': '— nicht klassifiziert —',
  'Subjects — comma-separated': 'Themen — durch Komma getrennt',
  'Summary — one line': 'Zusammenfassung — eine Zeile',
  'Effective date — the date the content was true': 'Stichtag — das Datum, an dem der Inhalt galt',
  'Source type': 'Quellentyp',
  'upload': 'Upload',
  'transcript': 'Transkript',
  'note': 'Notiz',
  'url': 'URL',
  'Authored by': 'Verfasst von',
  'Save — and hold it': 'Speichern — und übernehmen',
  'Cancel': 'Abbrechen',
  'Form': 'Form',
  'Subjects': 'Themen',
  'The summary is the lead line at the top of this panel — stated once.': 'Die Zusammenfassung ist die Leitzeile oben in diesem Panel — einmal genannt.',
  'Hold this classification': 'Diese Klassifikation übernehmen',
  'Edit…': 'Bearbeiten…',
  'Ask the librarian to file it again — your edits always outrank the model': 'Den Bibliothekar erneut ablegen lassen — Ihre Änderungen haben immer Vorrang vor dem Modell',
  'Classifying…': 'Wird klassifiziert…',
  'Re-run the librarian': 'Bibliothekar erneut starten',
  'Provenance': 'Herkunft',
  'confirmed': 'bestätigt',
  'unconfirmed': 'unbestätigt',
  'Status': 'Status',
  'processing': 'in Verarbeitung',
  'ready': 'bereit',
  'superseded': 'ersetzt',
  'Source': 'Quelle',
  'uploaded here': 'hier hochgeladen',
  'linked from library': 'aus der Bibliothek verknüpft',
  'from library': 'aus der Bibliothek',
  'Ingested': 'Eingelesen',
  'Size': 'Grösse',
  '{n} pages': '{n} Seiten',
  'Superseded by': 'Ersetzt durch',
  'Supersedes': 'Ersetzt',
  'Re-uploaded': 'Erneut hochgeladen',
  '— identical bytes arrived again and were not duplicated. Last:': '— identische Bytes kamen erneut an und wurden nicht dupliziert. Zuletzt:',
  'Linked engagements': 'Verknüpfte Aufträge',
  'Not linked anywhere — this document lives only in the client library.': 'Nirgends verknüpft — dieses Dokument lebt nur in der Kundenbibliothek.',
  'portal': 'Portal',
  'Unlink': 'Verknüpfung lösen',
  'Open full size in a new tab': 'In voller Grösse in neuem Tab öffnen',
  'Download original': 'Original herunterladen',
  'Hide the extracted text': 'Extrahierten Text ausblenden',
  'Read the extracted text': 'Extrahierten Text lesen',
  'Re-read with OCR': 'Mit OCR neu lesen',
  'This text was transcribed from the image by {model} across {n} page(s).': 'Dieser Text wurde von {model} über {n} Seite(n) aus dem Bild transkribiert.',
  'This text was transcribed from the image by {model}.': 'Dieser Text wurde von {model} aus dem Bild transkribiert.',
  'the vision model': 'dem Vision-Modell',
  'Evidence quoted from it is quoted from a machine transcription — check the original before it reaches a contract.': 'Daraus zitierte Belege stammen aus einer maschinellen Transkription — prüfen Sie das Original, bevor es in einen Vertrag gelangt.',
  'Only the first {pages} pages were read; {rest} remain.': 'Nur die ersten {pages} Seiten wurden gelesen; {rest} verbleiben.',
  'OCR failed:': 'OCR fehlgeschlagen:',
  'Show all {n} chars': 'Alle {n} Zeichen zeigen',
  'Show first {n}': 'Erste {n} zeigen',
  'This source produced no text layer.': 'Diese Quelle hat keine Textebene ergeben.',
  'Attachment re-scan —': 'Neuscan der Anhänge —',
  'attachment': 'Anhang',
  'attachments': 'Anhänge',
  'already present': 'bereits vorhanden',
  'unsupported': 'nicht unterstützt',
  'Disposals — supersede, unlink, delete': 'Entsorgung — ersetzen, Verknüpfung lösen, löschen',
  'Supersede': 'Ersetzen',
  'keeps a document that was real and has been overtaken — it keeps its evidence and its place in the chain.': 'behält ein Dokument, das echt war und überholt wurde — es behält seine Belege und seinen Platz in der Kette.',
  'removes it from': 'entfernt es aus',
  'only; it stays in the client library.': '— nur dort; es bleibt in der Kundenbibliothek.',
  'Delete': 'Löschen',
  'is for one that should never have been ingested: the row and the file go, and only the audit entry survives.': 'ist für eines, das nie hätte eingelesen werden sollen: die Zeile und die Datei gehen, nur der Prüfpfad-Eintrag überlebt.',
  'Mark superseded by…': 'Als ersetzt markieren durch…',
  '— not superseded —': '— nicht ersetzt —',
  'no date': 'ohne Datum',
  'Apply': 'Anwenden',
  'Clear supersession': 'Ersetzung aufheben',
  'Delete {ref}': '{ref} löschen',

  // ── new note ──
  'Title': 'Titel',
  'e.g. Toby — regulatory affairs scoping call': 'z. B. Toby — Scoping-Gespräch Regulatory Affairs',
  'Effective date (optional)': 'Stichtag (optional)',
  'Body (markdown)': 'Text (Markdown)',
  'Notes become first-class evidence — requirements can cite a verbatim span of this text.': 'Notizen werden vollwertige Belege — Anforderungen können eine wörtliche Stelle dieses Textes zitieren.',
  'Saving…': 'Wird gespeichert…',
  'Create note': 'Notiz erstellen',

  // ── library picker ──
  'Add from the client library': 'Aus der Kundenbibliothek hinzufügen',
  'These documents already exist in the client library and are not linked to': 'Diese Dokumente existieren bereits in der Kundenbibliothek und sind nicht verknüpft mit',
  'Linking makes them part of this engagement’s corpus — nothing is copied, and unlinking later leaves the document untouched.': 'Durch Verknüpfen werden sie Teil des Korpus dieses Auftrags — nichts wird kopiert, und ein späteres Lösen lässt das Dokument unberührt.',
  'Search ref, filename, tag…': 'Ref, Dateiname, Tag suchen…',
  'Nothing to link': 'Nichts zu verknüpfen',
  'No unlinked library documents match these filters.': 'Keine unverknüpften Bibliotheksdokumente entsprechen diesen Filtern.',
  'Every document in the client library is already linked to {code}.': 'Jedes Dokument der Kundenbibliothek ist bereits mit {code} verknüpft.',
  'Clear the picker filters': 'Auswahlfilter zurücksetzen',
  'Used by': 'Verwendet von',
  'library only': 'nur Bibliothek',
  'Linking…': 'Wird verknüpft…',
  'Link': 'Verknüpfen',
  'Done': 'Fertig',

  // ── confirm modals ──
  'Mark as superseded': 'Als ersetzt markieren',
  'Mark superseded': 'Als ersetzt markieren',
  'The document keeps its evidence and stays downloadable — supersession is a status and a pointer, never a deletion. Recency arbitration will prefer the later document.': 'Das Dokument behält seine Belege und bleibt herunterladbar — Ersetzung ist ein Status und ein Verweis, nie eine Löschung. Der Aktualitätsabgleich bevorzugt das spätere Dokument.',
  '{ref} cannot be deleted': '{ref} kann nicht gelöscht werden',
  'This document': 'Dieses Dokument',
  'Deleting…': 'Wird gelöscht…',
  'Delete permanently': 'Endgültig löschen',
  'Supersede it instead': 'Stattdessen ersetzen',
  'The row and the file on disk go immediately. The audit log keeps the full record.': 'Die Zeile und die Datei auf der Platte gehen sofort. Der Prüfpfad behält den vollständigen Eintrag.',
  'go with it': 'gehen mit',
  'It is linked into': 'Es ist verknüpft in',
  '— every one of those engagements loses it from its corpus.': '— jeder dieser Aufträge verliert es aus seinem Korpus.',
  'This cannot be undone.': 'Das kann nicht rückgängig gemacht werden.',
  'Cited by': 'Zitiert von',
  'Drop the evidence link on each of these in the Register and the document becomes deletable.': 'Lösen Sie im Register bei jeder dieser Anforderungen die Belegverknüpfung, dann wird das Dokument löschbar.',
  'Unlink {ref} from {code}': 'Verknüpfung von {ref} mit {code} lösen',
  'The document stays in the client library and in every other engagement that links it — only': 'Das Dokument bleibt in der Kundenbibliothek und in jedem anderen Auftrag, der es verknüpft — nur',
  'loses it from its corpus. The link’s note and its portal publish flag go with the link; re-linking later starts clean.': 'verliert es aus seinem Korpus. Die Notiz der Verknüpfung und ihr Portal-Freigabeflag gehen mit der Verknüpfung; ein späteres Neuverknüpfen beginnt sauber.',
  '{ref} cannot be unlinked from {code}': 'Verknüpfung von {ref} mit {code} kann nicht gelöst werden',
  'Got it': 'Verstanden',
  'Drop the evidence link on each of these in the Register, then unlink.': 'Lösen Sie im Register bei jeder dieser Anforderungen die Belegverknüpfung, dann lösen Sie die Verknüpfung.',

  // ── the pair decider ──
  'later': 'später',
  'longer': 'länger',
  'not linked to this engagement': 'nicht mit diesem Auftrag verknüpft',
  'chars': 'Zeichen',
  'spans cited': 'Stellen zitiert',
  'no spans cited': 'keine Stellen zitiert',
  '{loser} superseded by {winner}': '{loser} ersetzt durch {winner}',
  'same content': 'gleicher Inhalt',
  'same filename': 'gleicher Dateiname',
  'same base name': 'gleicher Basisname',
  'similar name': 'ähnlicher Name',
  'Not duplicates': 'Keine Duplikate',
  'is later and longer — first verb': 'ist später und länger — erstes Verb',
  'no ordering fact separates them': 'kein Ordnungsmerkmal trennt sie',
  'the other half is not linked to this engagement': 'die andere Hälfte ist nicht mit diesem Auftrag verknüpft',

  // ── evidence block ──
  'chars {start}–{end}': 'Zeichen {start}–{end}',
  'cited by': 'zitiert von',
  'Requirement status: {status}': 'Status der Anforderung: {status}',

  // ── DOCUMENT_FOLDERS (chips, options, form line) ──
  'correspondence': 'Korrespondenz',
  'meeting': 'Besprechung',
  'agreement': 'Vereinbarung',
  'financial': 'Finanzen',
  'specification': 'Spezifikation',
  'presentation': 'Präsentation',
  'image': 'Bild',
  'deliverable': 'Arbeitsergebnis',
  'reference': 'Referenz',
}, 'DocumentsPage');
